import React from "react";
import "./CollectionOval.css";

/**
 * iCRAFTZ Design System · <CollectionOval>
 *
 * The circular collection card used in the Homepage's "Explore
 * Popular Collections" strip.
 *
 * Props
 * ─────
 * image        URL of the medallion image (optional)
 * icon         Fallback icon if image is missing
 * title        Collection title (e.g. "Habits", "Focus & Deep Work")
 * href / onClick   navigation target
 */
export function CollectionOval({
  image,
  icon,
  title,
  href,
  onClick,
  className = "",
  ...rest
}) {
  const Tag = href ? "a" : "button";
  return (
    <Tag
      className={["icz-oval", className].filter(Boolean).join(" ")}
      href={href}
      onClick={onClick}
      type={href ? undefined : "button"}
      aria-label={title}
      {...rest}
    >
      <span className="icz-oval__medallion" aria-hidden="true">
        {image ? <img src={image} alt="" /> : icon}
      </span>
      <span className="icz-oval__title">{title}</span>
    </Tag>
  );
}

export default CollectionOval;
